import profileImg from "../asset/img/profile.png";

const personal = {
    "name": "Khang Hoang Tran",
    "title": "DevSecOps Engineer & Cloud Enthusiast",
    "imageUrl": profileImg, 
    "socialLinks": {
        "github": "https://github.com/khangtictoc",
        "linkedin": "https://linkedin.com/in/yourusername",
        "twitter": "https://twitter.com/yourusername"
    },
    "contact": {
        "email": "tranhoangkhang09112001@gmail.com",
        "phone": "+1 234 567 890",
        "location": "Ho Chi Minh, VN"
    }
};

export default personal; 